/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Naven Rajkumar",
  title: "Hi all, I'm Naven",
  subTitle: emoji(
    "🚀 Passionate software developer crafting apps for everyday ease and massive impact. Experienced in developing with Java / JavaScript / ReactJS. Let's build something amazing together! 🌟💻"
  ),
  resumeLink:
    "https://drive.google.com/file/d/11gTFSO2A3_0p5rnG9HIYbwAdHMyyEFB9/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/NavenAllen",
  linkedin: "https://www.linkedin.com/in/naven-rajkumar/",
  gmail: "naven.srajkumar@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "An adventurous full-stack developer eager to dive into every tech stack out there! ",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    // {
    //   skillName: "sass",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    // {
    //   skillName: "firebase",
    //   fontAwesomeClassname: "fas fa-fire"
    // },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Arizona State University",
      logo: require("./assets/images/asuLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "August 2022 - May 2024 (Expected)",
      desc: "CGPA: 4.0/4.0",
      descBullets: [
        "Data Processing at Scale", "Computer Systems Security", "Advanced Operating Systems", "Cloud Computing"
      ]
    },
    {
      schoolName: "National Institute of Technology, Trichy",
      logo: require("./assets/images/nittLogo.png"),
      subHeader: "Bachelor of Technology in Electronics and Communications Engineering",
      duration: "July 2016 - June 2020",
      desc: "Minor in Computer Science",
      descBullets: ["Data Structure and Algorithms", "Database Management Systems", "Software Engineering"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Development Engineer",
      company: "Visa",
      companylogo: require("./assets/images/visaLogo.png"),
      date: "October 2020 – July 2022",
      desc: "Worked on Visa Partner Portal",
      descBullets: [
        "Migrated a backend of 20+ APIs from Servlets to Spring Boot Microservice that resulted in 5x increased performance by following design patterns and object-oriented programming.",
        "Awarded DDP Star Award for exceptional performance during the second quarter of FY 2022.",
        "Built and shipped a Self Serve Portal for admins to edit existing forms, removing the responsibility of seeding changes from  developers, saving 100+ engineering hours per release."
      ]
    },
    {
      role: "Software Engineering Intern",
      company: "Visa",
      companylogo: require("./assets/images/visaLogo.png"),
      date: "May 2019 – June 2019",
      descBullets: [
        "Streamlined the Asset upload process by creating a custom Workflow Engine Broker with Java Spring Boot, seamlessly integrated with MySQL, automating asset management.", 
        "Improved the pipeline time for malware scans by 10%, by integrating the management pipeline with Visa Secure File Upload.",
        "Reduce the time to build and deploy to production by 80% through the implementation of an automated build pipeline using Jenkins and shell scripting."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Inkmonk",
      companylogo: require("./assets/images/inkmonkLogo.jpg"),
      date: "May 2018 – July 2018",
      descBullets: [
        "Integrated various payment Gateways for seamless customer experience by working closely with the development team to create an API to integrate the payment gateway.",
        "Added a new feature for Automatic Quotation Generation that reduced wait time by 10x."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      // image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Awards and Certifications 🏆 "),
  subtitle:
    "Achievements and Certifications that I have earned!",

  achievementsCards: [
    {
      title: "AWS Solutions Architect Associate",
      subtitle:
        "Earned the AWS SAA-C03 certification and hosted this website on AWS along with a neat View Counter powered by the AWS Serverless Architecture!",
      image: require("./assets/images/awsSAALogo.jpeg"),
      imageAlt: "AWS Solutions Architect Associate Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/46813e21-4006-433b-8c27-12d8156f8af0/public_url"
        }
      ]
    },
    {
      title: "Yellow Belt at pwn.college",
      subtitle:
        "Awarded for completing all the 355 Capture the Flag challenges during the Computer Systems Security course at ASU during Fall '22",
      image: require("./assets/images/pwnLogo.ico"),
      imageAlt: "Pwn College Logo",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://www.credly.com/badges/46813e21-4006-433b-8c27-12d8156f8af0/public_url"
        // }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+1-6028493268",
  // email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
